import { Controller } from '@hotwired/stimulus'

/**
 * body に用意した global な名前空間に対して操作を行える Stimulus Controller
 */
export class GlobalController extends Controller {
}
